/**
 * LaneChips - which kinds of line the shared log shows (v9.7.0).
 *
 * One chip per lane (engine/log/lanes): Combat, Tests, Story, Vox,
 * Handouts. A lit chip's lines are shown; a press switches it. The choice
 * is the viewer's own and is remembered. A lane holding lines that arrived
 * while the viewer was NOT following the log says how many
 * (engine/log/readMark), lit or not. Following along at the foot reads
 * every lane as it lands, the hidden ones too: a lane switched off is one
 * the viewer chose not to hear from.
 *
 * @param {object} props
 * @param {string[]} props.hidden - the lanes switched off
 * @param {(lane: string) => void} props.onToggle
 * @param {Record<string, number>} [props.counts] - new lines per lane
 */
import styles from '../../styles/CombatLogPanel.module.css';
import clsx from '../../utils/clsx';
import { LANES, LANE_LABELS } from '../../engine/log/lanes';

export default function LaneChips({ hidden, onToggle, counts = {} }) {
  return (
    <div className={styles.laneChips} role="group" aria-label="What the log shows">
      {LANES.map((lane) => {
        const on = !hidden.includes(lane);
        const fresh = counts[lane] ?? 0;
        return (
          <button
            key={lane}
            type="button"
            className={clsx(styles.laneChip, on && styles.laneChipOn)}
            aria-pressed={on}
            data-testid={`log-lane-${lane}`}
            title={on ? `Hide ${LANE_LABELS[lane]} lines` : `Show ${LANE_LABELS[lane]} lines`}
            onClick={() => onToggle(lane)}
          >
            {LANE_LABELS[lane]}
            {fresh > 0 && (
              <span className={styles.laneCount} data-testid={`log-lane-count-${lane}`} aria-label={`${fresh} new`}>
                {fresh}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
